import React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { saveUserData } from '../redux/slices/userSlice';
import { jwtDecode } from 'jwt-decode';

// A wrapper for <Route> that redirects to login screen if you're not yet authenticated.
function ProtectedRoute({ allowedRoles }) {
    const token = localStorage.getItem('token');
    let user = null;
    let location = useLocation();
    let dispatch = useDispatch();

    if (token) {
        try {
            // Decode token and store user data in Redux
            user = jwtDecode(token);
            dispatch(saveUserData(user));
        } catch (error) {
            console.error('Invalid token:', error);
        }
    }
    
    // Check if the user exists and if their role is allowed
    if (user && allowedRoles.includes(user.role)) {
        return <Outlet />;
    }

    // Handle unauthorized access
    if (user?.isLogin && user?.isActive) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
}

export default ProtectedRoute;
